import { ButtonLink } from "@/components/ui/button";
import S from "./index.module.scss";
import clsx from "clsx";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import React, { FC, useState } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import { VacancyGroupResource } from "@/api/generated-api";

interface IVacanciesList {
  vacancy: VacancyGroupResource;
}

dayjs.locale("ru");

const VacanciesItem: FC<IVacanciesList> = ({ vacancy }) => {
  const [open, setOpen] = useState(false);

  const currentYear = dayjs().year();

  return (
    <div className={S.wrapper}>
      <div className={S.titleWrapper}>
        <h3 className={clsx(S.title, { [S["title--open"]]: open })} onClick={() => setOpen(value => !value)}>
          {vacancy.name}
        </h3>
        <span>{vacancy.vacancies.length}</span>
      </div>
      {open && (
        <div className={S.list}>
          {vacancy.vacancies.map(item => {
            const pubDate = dayjs(item.published_at);
            const displayDate =
              pubDate.year() !== currentYear ? pubDate.format("DD MMMM YYYY") : pubDate.format("DD MMMM");

            return (
              <React.Fragment key={item.origin_id}>
                <div className={S.item}>
                  <p className={S.itemTitle}>
                    {item.name}
                    <span className={S.itemDate}>{displayDate}</span>
                  </p>
                  <p className={S.itemSalary}>{item.salary_from ? `от ${item.salary_from} руб.` : "з/п не указана"}</p>
                  <p className={S.itemAddress}>
                    {item.city}
                    {item.metro && <span className={S.itemMetro}>{item.metro}</span>}
                    <span className={S.itemDate}>{displayDate}</span>
                  </p>

                  <ButtonLink target="_blank" href={item.url} variant="trBlueToBlack">
                    Откликнуться <CustomIcon fileName="icon-exit" />
                  </ButtonLink>
                </div>
                <span className={S.line}></span>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VacanciesItem;
